<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { 
        fetchProductos, 
        saveProducto, 
        removeProducto, 
        searchProductos, 
        subscribeToProductos, 
        unsubscribeFromProductos 
    } from '../controllers/productoController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de productos
    let productoColumns = [
        { label: 'SKU', field: 'sku', type: 'text' },
        { label: 'Descripción', field: 'descripcion', type: 'text' },
        { label: 'Sucursal', field: 'sucursal', type: 'relation', relationField: 'descrip' },
        { label: 'Último Costo', field: 'ultimo_costo', type: 'number' },
        { label: 'Estado', field: 'sta', type: 'bool' }
    ];

    // Estructura del nuevo objeto Producto
    let newProducto = {
        sucursal: null, // Relación con la sucursal
        sku: '',
        descripcion: '',
        servicio: false,
        ultimo_costo: 0,
        fecha_ultcosto: "0000-00-00",
        ultimo_costo_imp: 0,
        sta: true
    };

    // Configuración de los campos para la edición de productos
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'SKU', key: 'sku', type: 'text', required: true },
        { label: 'Descripción', key: 'descripcion', type: 'text', required: true },
        { label: 'Servicio', key: 'servicio', type: 'checkbox', required: false },
        { label: 'Último Costo', key: 'ultimo_costo', type: 'number', required: true },
        { label: 'Fecha Último Costo', key: 'fecha_ultcosto', type: 'text', required: true, placeholder: "AAAA-MM-DD" },
        { label: 'Último Costo con Impuestos', key: 'ultimo_costo_imp', type: 'number', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox', required: true }
    ];

    // Función para cargar y transformar sucursales
    let sucursalOptions = [];

    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title="Productos"
    entityName="producto"
    newEntity={newProducto}
    columns={productoColumns}
    fetchEntities={fetchProductos}
    saveEntity={saveProducto}
    removeEntity={removeProducto}
    searchEntities={searchProductos}
    subscribeToChanges={subscribeToProductos}
    unsubscribeFromChanges={unsubscribeFromProductos}
    editColumns={editColumns}
/>
